<template>
  <Toast />
  <Toolbar class="box mt-4 p-p-2">
    <template #start>
      <back-button />
    </template>
    <template #end>
      <Button
        type="button"
        class="p-button-info p-button-sm"
        icon="pi pi-info"
        @click="getInfoFinancialProduct"
      ></Button>
    </template>
  </Toolbar>

<!--  <InfoFinancialProduct :info="financialProduct" />-->

  <div class="grid grid-cols-12 gap-6 mt-5">
    <div class="intro-y col-span-12 lg:col-span-12">
      <div class="intro-y box">
        <div
          class="flex flex-col sm:flex-row justify-between items-center p-3 border-b border-gray-200 dark:border-dark-5"
          :style="`border-top-left-radius: 6px; border-top-right-radius: 6px;  border-top-color: ${isEdit ? '#FAB711' : '#065f46'}; border-top-width: 8px;`"
        >
          <h2 class="font-medium text-lg mr-auto">{{ isEdit ? 'Editar Compra Tarjeta de Crédito' : 'Nueva Compra Tarjeta de Crédito' }}</h2>
        </div>
        <div class="p-5 custom-style">
          <form action="" @submit.prevent="onSubmit">
            <div class="grid grid-cols-12 gap-6">

              <div class="col-span-12 lg:col-span-7">
                <Fieldset legend="Datos de Compra" :toggleable="true" class="p-2">
                  <div class="p-fluid p-formgrid p-grid" >
                    <div class="p-field p-col-12 p-md-12">
                      <label>Producto Financiero:</label>
                      <Dropdown
                        id="banco"
                        v-model="modelo.productId"
                        :options="listCreditCards"
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Seleccione una opción"
                        :filter="true"
                        scrollHeight="auto"
                        filterPlaceholder="Buscar por nombre"
                        :class="{ 'p-invalid': errors.productId }"
                        @change="getInfoCreditCard"
                      />
                      <MessageError :text="errors.productId" />
                    </div>

                    <div class="p-field p-col-12 p-md-6">
                      <label for="term"># Cuotas a Diferir:</label>
                      <InputText
                        id="term"
                        type="number"
                        v-model="modelo.quotas"
                        :class="{ 'p-invalid': errors.quotas }"
                      />
                      <MessageError :text="errors.quotas" />
                    </div>

                    <div class="p-field p-col-12 p-md-6">
                      <label for="term">Fecha de la Compra:</label>
                      <InputText
                        id="purchaseDate"
                        type="date"
                        v-model="modelo.purchaseDate"
                        :class="{ 'p-invalid': errors.purchaseDate }"
                      />
                      <MessageError :text="errors.purchaseDate" />
                    </div>

                    <div class="p-field p-col-12 p-md-6">
                      <label for="disbursement">Valor de la Compra: ($)</label>
                      <InputNumber
                        id="disbursement"
                        v-model="modelo.valueShopping"
                        mode="currency" currency="COP"
                        locale="es-CO"
                        minFractionDigits="0"
                        maxFractionDigits="0"
                        :class="{ 'p-invalid': errors.valueShopping }"
                      />
                      <MessageError :text="errors.valueShopping" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                      <label for="disbursement">Valor del interés: ($)</label>
                      <InputNumber
                        id="interest"
                        v-model="modelo.interest"
                        mode="currency" currency="COP"
                        locale="es-CO"
                        minFractionDigits="0"
                        maxFractionDigits="0"
                        :class="{ 'p-invalid': errors.interest }"
                      />
                      <MessageError :text="errors.interest" />
                    </div>
                    <div class="p-field p-col-12 p-md-8" :class="isEdit ? 'p-md-12' : 'p-md-8'">
                      <label for="description">Descripción:</label>
                      <Textarea
                        v-model="modelo.description"
                        id="description"
                        :class="{ 'p-invalid': errors.description }"
                        :autoResize="true"
                        rows="1"
                        maxlength="50"
                      />
                      <MessageError :text="errors.description" />
                    </div>
                    <div class="p-field p-col-12 p-md-4" v-if="!isEdit">
                      <label for="">&nbsp;</label>
                      <Button label="Generar Detalle" class="p-button-raised p-button-secondary" @click="generateShoppings" />
                    </div>
                  </div>
                </Fieldset>
              </div>

              <div class="col-span-12 lg:col-span-5">
                <Fieldset legend="Información de la Tarjeta de Crédito" :toggleable="true" class="p-2">
                  <div v-if="!Object.keys(infoCreditCard).length" class="w-full mb-2">
                    <div class="p-2">
                      <p class="text-base font-bold mb-4">Selecciona un producto financiero para visualizar la información</p>
                      <div class="grid grid-cols-12 gap-4 gap-y-4">
                        <div class="col-start-1 col-end-3 col-span-4 h-12 rounded-sm bg-gray-300 animate-pulse"></div>
                        <div class="col-start-8 col-end-13 h-12 rounded-sm bg-gray-300 animate-pulse"></div>
                        <div class="col-start-1 col-end-6 h-6 rounded-sm bg-gray-300 animate-pulse"></div>
                        <div class="col-start-9 col-end-13 h-6 rounded-sm bg-gray-300 animate-pulse"></div>
                        <div class="col-start-1 col-end-6 h-8 rounded-sm bg-gray-300 animate-pulse"></div>
                        <div class="col-start-9 col-end-13 h-8 rounded-sm bg-gray-300 animate-pulse"></div>
                        <div class="col-start-1 col-end-13 h-6 "></div>
                        <div class="col-start-1 col-end-6 h-6 rounded-sm bg-gray-300 animate-pulse"></div>
                        <div class="col-start-1 col-end-6 h-8 rounded-sm bg-gray-300 animate-pulse"></div>
                        <div class="col-start-9 col-end-13 h-8 rounded-sm bg-gray-300 animate-pulse"></div>
                      </div>
                    </div>
                  </div>
                  <InfoCreditCard v-else :info="infoCreditCard" :imageLink="imageLink" :bgGradient="bgGradient" />
                </Fieldset>
              </div>
            </div>

            <Fieldset legend="Detalle Compras" :toggleable="true" class="p-2 mt-6">
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-12">

                  <div v-if="modelo.detailsShopping.length <= 0"  class="box w-full p-4">
                    <div class="flex flex-col justify-center items-center">
                      <div class="w-full sm:w-1/3">
                        <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 739 468" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M853.24364,705.75529l2-.03906a463.83054,463.83054,0,0,0-7.09961-66.28711c-8.64843-46.88086-23.02929-77.66993-42.74316-91.51172l-1.14844,1.63672C850.30419,581.8881,853.22021,704.51994,853.24364,705.75529Z" transform="translate(-241.37629 -238.42268)" fill="#2f2e41"/><path d="M828.24364,705.27677l2-.03906c-.043-2.21484-1.293-54.41406-21.84277-68.8418l-1.14844,1.63672C826.97314,651.87834,828.23388,704.74455,828.24364,705.27677Z" transform="translate(-241.37629 -238.42268)" fill="#2f2e41"/><circle cx="551.49821" cy="301.31307" r="10.00001" fill="#6c63ff"/><circle cx="556.45036" cy="387.31309" r="10" fill="#6c63ff"/><path d="M832.90487,555.73032c-1.87935,12.004,3.0189,22.74061,3.0189,22.74061s7.9453-8.72583,9.82465-20.72986-3.01891-22.7406-3.01891-22.7406S834.78423,543.7263,832.90487,555.73032Z" transform="translate(-241.37629 -238.42268)" fill="#2f2e41"/><path d="M800.2177,584.88413c11.493,3.9422,22.91878.98963,22.91878.98963s-7.20793-9.34412-18.70088-13.28632-22.91879-.98962-22.91879-.98962S788.72475,580.94193,800.2177,584.88413Z" transform="translate(-241.37629 -238.42268)" fill="#2f2e41"/><path d="M799.84846,661.04527a31.13456,31.13456,0,0,0,16.06421.69366,28.37373,28.37373,0,0,0-29.172-10.00629A31.13421,31.13421,0,0,0,799.84846,661.04527Z" transform="translate(-241.37629 -238.42268)" fill="#2f2e41"/><path d="M566.4728,393.61993,502.0001,360.0942s-21.65069-23.84322-35.24783-34.61282-17.7827-2.85791-17.7827-2.85791l-5.71575,9.52636,13.81324,19.21174,37.3119,31.59606,66.66975,26.1135a10.572,10.572,0,1,0,5.42409-15.4512Z" transform="translate(-241.37629 -238.42268)" fill="#9f616a"/><path d="M398.77329,364.6245l-3.81708-23.35225-10.778-2.69445s-8.5538-2.63477-10.55317,14.59512-.44926,49.39894-.44926,49.39894l-21.88282,69.29535a10.59585,10.59585,0,1,0,14.7613,7.09018l28.6776-65.60761Z" transform="translate(-241.37629 -238.42268)" fill="#9f616a"/><polygon points="246.545 453.915 260.648 453.914 267.358 399.515 246.542 399.516 246.545 453.915" fill="#9f616a"/><path d="M484.32357,687.733l27.7751-.00113h.00112a17.70143,17.70143,0,0,1,17.70047,17.70019v.57519l-45.47584.00169Z" transform="translate(-241.37629 -238.42268)" fill="#2f2e41"/><polygon points="92.716 453.915 106.82 453.914 113.529 399.515 92.714 399.516 92.716 453.915" fill="#9f616a"/><path d="M330.49508,687.733l27.7751-.00113h.00112a17.70142,17.70142,0,0,1,17.70046,17.70019v.57519l-45.47584.00169Z" transform="translate(-241.37629 -238.42268)" fill="#2f2e41"/><path d="M403.71931,317.97643l-23.39272,19.96935,19.19785,60.7527,4.33173,13.56614s-26.45012,24.38714-42.81585,92.5121-43.13826,158.64663-43.13826,158.64663l56.51213,16.17685L420.3905,525.49444l54.07908,120.90065,6.2437,35.75935,48.12555-14.19022-11.35218-89.68217-56.76087-155.241,5.89612-41.15164s8.85413-20.54034-6.5275-42.28684l-4.82467-20.43392-17.28336-4.25706Z" transform="translate(-241.37629 -238.42268)" fill="#2f2e41"/><path d="M442.58173,307.12036H379.33625a4.91252,4.91252,0,0,1-4.907-4.907v-27.261a36.52972,36.52972,0,0,1,73.05944,0v27.261A4.91252,4.91252,0,0,1,442.58173,307.12036Z" transform="translate(-241.37629 -238.42268)" fill="#2f2e41"/><circle cx="418.46547" cy="279.70344" r="26.78231" transform="translate(-269.05901 274.30256) rotate(-61.3368)" fill="#9f616a"/><path d="M456.13076,277.6785H417.4577l-.39667-5.5523-1.98281,5.5523H409.1234l-.78589-11.00449-3.92994,11.00449h-11.5223v-.54522a28.92911,28.92911,0,0,1,28.89638-28.89665h5.45246a28.92933,28.92933,0,0,1,28.89665,28.89665Z" transform="translate(-241.37629 -238.42268)" fill="#2f2e41"/><path d="M417.14119,312.20917a5.01187,5.01187,0,0,1-.86841-.07667l-28.31815-4.99643V260.3345h31.17283l-.77177.89983c-10.73774,12.523-2.6481,32.82925,3.12969,43.81883a4.83436,4.83436,0,0,1-.38416,5.13274A4.88728,4.88728,0,0,1,417.14119,312.20917Z" transform="translate(-241.37629 -238.42268)" fill="#2f2e41"/><path d="M651.33014,557.56836,403.14905,645.3151a24.56673,24.56673,0,0,1-31.3153-14.95575l-42.634-120.58516a24.56674,24.56674,0,0,1,14.95574-31.3153l248.18109-87.74674a24.56674,24.56674,0,0,1,31.31531,14.95575l42.634,120.58516A24.56674,24.56674,0,0,1,651.33014,557.56836Z" transform="translate(-241.37629 -238.42268)" fill="#fff"/><path d="M666.28589,526.25306l.22556.638A23.43487,23.43487,0,0,1,652.224,556.7949L402.802,644.98037a23.43325,23.43325,0,0,1-29.90121-14.28054l-.22556-.638Z" transform="translate(-241.37629 -238.42268)" fill="#f2f2f2"/><path d="M387.66123,506.4563c-16.45068,10.82463-37.53445,2.67823-44.90812-9.18765l1.1756-.668C357.93373,487.87106,378.73225,492.73472,387.66123,506.4563Z" transform="translate(-241.37629 -238.42268)" fill="#6c63ff"/><path d="M593.81186,537.16748c-4.02657,1.42363-7.652,1.35832-10.77693-.19413-7.06267-3.50917-10.37681-13.91434-13.03981-22.27525-.77484-2.43225-1.50665-4.7299-2.25186-6.60766l-.01067-.02855a14.97351,14.97351,0,0,1,9.07371-19.01164l33.38227-11.80262c4.02143-1.42181,7.643-1.35706,10.76531.19286,7.06092,3.50478,10.37781,13.90628,13.04317,22.264.77716,2.4372,1.51123,4.73944,2.25914,6.6201a14.98288,14.98288,0,0,1-9.07011,19.04308ZM569.13122,507.5562c.76229,1.92294,1.5,4.2389,2.28081,6.69062,2.57783,8.09332,5.78611,18.16585,12.28461,21.39462,2.78927,1.38574,5.93592,1.42625,9.61931.124l33.37233-11.7991a13.48617,13.48617,0,0,0,8.17505-17.12113c-.75629-1.9-1.498-4.22613-2.2833-6.689-2.58-8.09024-5.79087-18.15914-12.28746-21.3836-2.78646-1.38327-5.92989-1.42337-9.60814-.12289l-33.38034,11.80193A13.48267,13.48267,0,0,0,569.13122,507.5562Z" transform="translate(-241.37629 -238.42268)" fill="#3f3d56"/><path d="M380.74224,510.354a33.179,33.179,0,0,1-18.23869,1.00256c-8.84066-1.94125-16.86391-7.21969-20.93832-13.7745l-.40839-.657,1.83484-1.04308c14.21571-8.85452,35.53266-4.05419,44.73394,10.08245l.40344.61988-.61776.40674A31.21918,31.21918,0,0,1,380.74224,510.354Zm-37.4934-12.90734c3.98747,5.92469,11.40744,10.66391,19.57373,12.45732a30.99955,30.99955,0,0,0,23.23925-3.75028c-9.00057-13.01914-28.94151-17.3378-42.29584-9.00152Z" transform="translate(-241.37629 -238.42268)" fill="#3f3d56"/><path d="M389.46138,596.90244a12.3428,12.3428,0,0,1-12.55072-2.0841,15.43877,15.43877,0,0,1-5.05061-14.27088,12.38646,12.38646,0,0,1,8.69877-9.60283l44.47892-15.72594a12.40825,12.40825,0,0,1,12.7924,2.0129,15.43853,15.43853,0,0,1,5.04415,14.27088c-.87831,4.58992-3.97714,7.9712-8.70064,9.58963L389.6939,596.81833Q389.5775,596.86121,389.46138,596.90244Zm-8.62591-24.48012a10.93106,10.93106,0,0,0-7.51452,8.40389,13.90851,13.90851,0,0,0,4.55026,12.85649,10.94121,10.94121,0,0,0,11.31642,1.73717l44.50084-15.73368a10.95848,10.95848,0,0,0,7.72506-8.46331,13.90705,13.90705,0,0,0-4.54468-12.85654,10.98845,10.98845,0,0,0-11.32542-1.749L381.03984,572.352c-.06831.023-.13685.04645-.20439.07034Z" transform="translate(-241.37629 -238.42268)" fill="#3f3d56"/><path d="M594.10935,501.6884l-14.02153,4.95745a3.718,3.718,0,1,1-2.47873-7.01077l14.02153-4.95744a3.718,3.718,0,1,1,2.47873,7.01076Z" transform="translate(-241.37629 -238.42268)" fill="#6c63ff"/><path d="M598.0753,512.90563l-14.02153,4.95744a3.718,3.718,0,1,1-2.47872-7.01076l14.02153-4.95745a3.718,3.718,0,0,1,2.47872,7.01077Z" transform="translate(-241.37629 -238.42268)" fill="#6c63ff"/><path d="M602.04125,524.12285l-14.02153,4.95745a3.718,3.718,0,0,1-2.47872-7.01077l14.02153-4.95744a3.718,3.718,0,1,1,2.47872,7.01076Z" transform="translate(-241.37629 -238.42268)" fill="#6c63ff"/><path d="M618.647,493.01288l-14.02153,4.95744a3.718,3.718,0,1,1-2.47872-7.01076l14.02153-4.95744a3.718,3.718,0,1,1,2.47872,7.01076Z" transform="translate(-241.37629 -238.42268)" fill="#6c63ff"/><path d="M622.613,504.2301l-14.02153,4.95745a3.718,3.718,0,1,1-2.47872-7.01077l14.02153-4.95744a3.718,3.718,0,0,1,2.47872,7.01076Z" transform="translate(-241.37629 -238.42268)" fill="#6c63ff"/><path d="M626.57893,515.44733l-14.02153,4.95744a3.718,3.718,0,1,1-2.47872-7.01076l14.02153-4.95745a3.718,3.718,0,0,1,2.47872,7.01077Z" transform="translate(-241.37629 -238.42268)" fill="#6c63ff"/><rect x="330.66409" y="483.77871" width="311.42176" height="1.48721" transform="matrix(0.94281, -0.33334, 0.33334, 0.94281, -375.06903, -48.58413)" fill="#3f3d56"/><path d="M651.33014,557.56836,403.14905,645.3151a24.56673,24.56673,0,0,1-31.3153-14.95575l-42.634-120.58516a24.56674,24.56674,0,0,1,14.95574-31.3153l248.18109-87.74674a24.56674,24.56674,0,0,1,31.31531,14.95575l42.634,120.58516A24.56674,24.56674,0,0,1,651.33014,557.56836ZM344.65123,479.861a23.078,23.078,0,0,0-14.04934,29.41741l42.634,120.58516a23.078,23.078,0,0,0,29.41741,14.04933L650.8344,556.16621a23.07794,23.07794,0,0,0,14.04933-29.41741l-42.634-120.58516a23.078,23.078,0,0,0-29.41741-14.04934Z" transform="translate(-241.37629 -238.42268)" fill="#3f3d56"/><path d="M979.37629,706.42268h-737a1,1,0,0,1,0-2h737a1,1,0,0,1,0,2Z" transform="translate(-241.37629 -238.42268)" fill="#cbcbcb"/></svg>
                      </div>
                      <span class="text-sm sm:text-base font-bold text-red-400 my-4 normal-case text-center">No hay información para mostrar, de clic en el botón "Generar Detalle" para visualizar las cuotas de las compras</span>
                    </div>
                  </div>

                  <div v-else>
                    <DataTable
                      :value="modelo.detailsShopping"
                      :scrollable="true"
                      scrollHeight="400px"
                      responsiveLayout="scroll"
                      showGridlines
                      class="p-datatable-sm"
                    >
                      <Column headerStyle="width: 1rem; text-align: center" bodyStyle="text-align: center; overflow: visible">
                        <template #body="{ data }">
                          <Button
                            type="button"
                            class="p-button-danger p-button-xs"
                            icon="pi pi-trash"
                            v-tooltip.top="'Eliminar fila'"
                            @click="removeRowShopping(data)"
                          ></Button>
                        </template>
                      </Column>
                      <Column header="# Cuota">
                        <template #body="{data}">
                          <InputText
                            id="quota"
                            type="number"
                            v-model="data.quota"
                            :class="{ 'p-invalid': errors[`detailsShopping[${data._key}].quota`] }"
                          />
                          <MessageError :text="errors[`detailsShopping[${data._key}].quota`]" />
                        </template>
                      </Column>
                      <Column header="Valor" bodyStyle="text-align: right">
                        <template #body="{data}">
                          <InputNumber
                            id="interest"
                            v-model="data.value"
                            mode="currency" currency="COP"
                            locale="es-CO"
                            minFractionDigits="0"
                            maxFractionDigits="4"
                            :class="{ 'p-invalid': errors[`detailsShopping[${data._key}].value`] }"
                          />
                          <MessageError :text="errors[`detailsShopping[${data._key}].value`]" />
                        </template>
                      </Column>
                      <Column header="Interés" bodyStyle="text-align: right">
                        <template #body="{data}">
                          <InputNumber
                            id="interest"
                            v-model="data.interest"
                            mode="currency" currency="COP"
                            locale="es-CO"
                            minFractionDigits="0"
                            maxFractionDigits="4"
                            :class="{ 'p-invalid': errors[`detailsShopping[${data._key}].interest`] }"
                          />
                          <MessageError :text="errors[`detailsShopping[${data._key}].interest`]" />
                        </template>
                      </Column>
                    </DataTable>

                    <div class="grid grid-cols-6 gap-4 mt-4">
                      <Button
                        label="Agregar Compra"
                        icon="pi pi-plus"
                        class="p-button-sm col-span-6 sm:col-span-3 md:col-span-3 lg:col-span-2 xl:col-span-1"
                        @click="addRowShopping"
                        v-tooltip.top="'Agregar Compra'"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Fieldset>

          </form>
        </div>
      </div>
    </div>

    <div class="intro-y col-span-12 lg:col-span-5">

    </div>

    <Button
      icon="pi pi-send"
      label="Guardar"
      class="p-button-success floating-button"
      @click="onSubmit"
    />
  </div>

</template>

<script>

import { computed, defineAsyncComponent, onMounted, ref } from 'vue'
import { useToast } from 'primevue/usetoast'
import { useStore } from 'vuex'
import listFinancialProducts from '../../../../services/listFinancialProducts'
import { array, number, object, string } from 'yup'
import { useField, useForm } from 'vee-validate'
import { error, errorHtml, messageConfirmSave, success } from '../../../../../../../../libs/mensajes'
import createShopping from '../../../../services/createShopping'
import { useRoute, useRouter } from 'vue-router'
import { helper } from '../../../../../../../../utils/helper'
import findShopping from '../../../../services/findShopping'
import listShoppingDetails from '../../../../services/listShoppingDetails'
import updateShopping from '../../../../services/updateShopping'
import updateShoppingDetails from '../../../../services/updateShoppingDetails'
import createShoppingDetails from '../../../../services/createShoppingDetails'

export default {
  name: 'shoppingForm',
  components: {
    InfoCreditCard: defineAsyncComponent(() => import('../infoCreditCard'))
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup (props) {
    const toast = useToast()
    const listCreditCards = ref([])
    const banks = ref([])
    const obligations = ref([])
    const store = useStore()
    const infoCreditCard = ref({})
    const imageLink = ref(null)
    const bgGradient = ref(null)
    const infoDetailsShopping = ref([])
    const router = useRouter()
    const route = useRoute()

    const isEdit = computed(() => {
      return !!route.params.id
    })

    const getInfoCreditCard = () => {
      if (modelo.productId) {
        store.dispatch('infoFinancialProductAmortization/financialProductAction', modelo.productId).then(() => {
          infoCreditCard.value = store.getters['infoFinancialProductAmortization/getFinancialProduct']
          setImageLink()
        })
      } else {
        toast.add({ severity: 'warn', summary: 'Advertencia', detail: 'Seleccione una opción de producto financiero', life: 3000 })
      }
    }

    const setImageLink = () => {
      console.log('info: ', infoCreditCard.value.bankId)
      if (infoCreditCard.value.bankId === 1) {
        imageLink.value = '/images/logo_banco_bogota.png'
        bgGradient.value = 'background:linear-gradient(135deg, #13f1fc 0%,#0470dc 100%)'
      } else if (infoCreditCard.value.bankId === 2) {
        imageLink.value = '/images/logo_bancolombia.svg'
        bgGradient.value = 'background:linear-gradient(135deg, #fcdf8a 0%,#f38381 100%)'
      } else if (infoCreditCard.value.bankId === 3) {
        imageLink.value = '/images/logo_davivienda.png'
        bgGradient.value = 'background:linear-gradient(135deg, #65799b 0%,#5e2563 100%)'
      } else if (infoCreditCard.value.bankId === 4) {
        imageLink.value = '/images/logo_scotiabank.png'
        bgGradient.value = 'background:linear-gradient(135deg, #F36265 0%,#961276 100%)'
      } else if (infoCreditCard.value.bankId === 5) {
        imageLink.value = '/images/logo_bbva.png'
        bgGradient.value = 'background:linear-gradient(135deg, #4a90e2 0%,#4ab8e2 100%)'
      } else if (infoCreditCard.value.bankId === 9) {
        imageLink.value = '/images/logo_bancoomeva.png'
        bgGradient.value = 'background:linear-gradient(135deg, #42e695 0%,#3bb2b8 100%)'
      }
    }

    /* Cargar en el dropdown los productos financieros que son tarjetas de credito (id: 9) */
    const loadDropdownFinancialProducts = async () => {
      const { data } = await listFinancialProducts({ per_page: 1000, obligationId: 9 })

      if (data) {
        listCreditCards.value = data.result.data
      } else {
        listCreditCards.value = []
      }
      toast.add({ severity: 'success', summary: 'Exito', detail: 'Tarjetas de crédito cargadas correctamente', life: 3000 })
    }

    /* Funcion para agregar una nueva fila (compras) */
    const addRowShopping = (event) => {
      modelo.detailsShopping.push({ quota: modelo.detailsShopping.length + 1, value: 0, interest: 0, id: null, _key: modelo.detailsShopping.length })
    }

    /* Funcion para remover la fila (compras) */
    const removeRowShopping = (data) => {
      modelo.detailsShopping.splice(data._key, 1)

      for (const key in modelo.detailsShopping) {
        modelo.detailsShopping[key]._key = key
      }
    }

    /* Generar compras automaticas */
    const generateShoppings = () => {
      modelo.detailsShopping = []
      if ([0, '0', '', null, undefined].includes(modelo.quotas) || [0, '0', '', null, undefined].includes(modelo.purchaseDate) || [0, '0', '', null, undefined].includes(modelo.valueShopping) || [0, '0', '', null, undefined].includes(infoCreditCard.value.bankId)) {
        toast.add({ severity: 'error', summary: 'Error', detail: 'Ingrese los datos requeridos para generar el detalle', life: 3000 })
      } else {
        for (let i = 0; i < modelo.quotas; i++) {
          console.log(modelo.valueShopping)
          modelo.detailsShopping.push({
            quota: i + 1,
            value: modelo.valueShopping / modelo.quotas,
            interest: modelo.interest / modelo.quotas,
            _key: i
          })
        }

        toast.add({ severity: 'success', summary: 'Exito', detail: 'Detalle de las compras generado correctamente', life: 3000 })
      }
      console.log('Quotas: ', modelo.quotas)
    }

    /* Obtener el producto financiero para editar (credit card) */
    const fetchCreditCard = (id) => {
      return findShopping({ id }).then(async ({ status, data: response }) => {
        console.log('Result: ', response.result)
        if (response.result.amortizationsProductId) {
          modelo.productId = response.result.amortizationsProductId
          modelo.quotas = response.result.diferido
          modelo.purchaseDate = response.result.purchaseDate
          modelo.valueShopping = response.result.value
          modelo.interest = response.result.interest
          modelo.description = response.result.description
          getInfoCreditCard()
        }
      }).catch((err) => {
        // loader.hide()
        console.error(err.message)
        if (err.response.status) {
          error(err.response.data.message)
        }
      })
    }

    /* Obtener el detalle de la compra */
    const fetchDetailsShopping = (id) => {
      return listShoppingDetails({ id }).then(async ({ status, data: resp }) => {
        modelo.detailsShopping = resp.result.map((detail, index) => {
          return {
            quota: detail.quota,
            value: detail.value,
            interest: detail.interest,
            _key: index,
            id: detail.id
          }
        })
      }).catch((err) => {
        // loader.hide()
        console.error(err.message)
        if (err.response.status) {
          error(err.response.data.message)
        }
      })
    }

    /* Esquema de validacion con sus reglas */
    const validationSchema = object({
      productId: string().nullable().required().label('Producto Financiero'),
      quotas: number().typeError('El campo es requerido').positive('').label('Cuotas'),
      valueShopping: number().typeError('El campo es requerido').positive().label('Valor de la Compra'),
      interest: number().typeError('El campo es requerido').label('Valor del interes'),
      purchaseDate: string().nullable().required().label('Fecha de la Compra'),
      description: string().nullable().required().label('Descripción'),
      detailsShopping: array().of(
        object({
          quota: number().typeError('El campo es requerido').positive().label('Cuota'),
          value: number().typeError('El campo es requerido').label('Valor'),
          interest: number().typeError('El campo es requerido').label('Interes')
        })
      )
    })

    /* Variables y propiedades del formulario para validar */
    const { errors, handleSubmit, values: modelo } = useForm({
      validationSchema
    })

    /* Inicializando campo en el formulario */
    useField('productId', null, { initialValue: null })
    useField('quotas', null, { initialValue: null })
    useField('valueShopping', null, { initialValue: 0 })
    useField('interest', null, { initialValue: 0 })
    useField('purchaseDate', null, { initialValue: null })
    useField('description', null, { initialValue: null })
    useField('detailsShopping', null, {
      initialValue: []
    })

    /* Funcion para validar el numero de cuotas */
    const validateNumQuotas = (detailsLength, quotas) => {
      if (parseInt(detailsLength) !== parseInt(quotas)) {
        errorHtml(
          'Validación',
          `<br>No es posible guardar las compras debido a que no coinciden el número de cuotas <strong>(${quotas})</strong> con el total de registros del detalle de las compras <strong>(${detailsLength})</strong>`
        )
        // loader.hide()
        return true
      }

      return false
    }

    // Funcion para validar el monto de la compra con el total del detalle
    const validateValueShopping = (values) => {
      let sumTotal = 0
      values.detailsShopping.forEach((item, i) => {
        sumTotal += item.value
      })

      if (values.valueShopping !== +sumTotal.toFixed(2)) {
        errorHtml(
          'Validación',
          `<br>El total de la compra <strong>(${helper.formatCurrency(values.valueShopping, 2)})</strong> debe ser igual al total del detalle <strong>(${helper.formatCurrency(sumTotal, 2)})</strong>`
        )
        // loader.hide()
        return true
      }
      return false
    }

    // Submit del envio de los datos
    const onSubmit = handleSubmit((values) => {
      if (validateNumQuotas(values.detailsShopping.length, values.quotas)) {
        return
      }

      if (validateValueShopping(values)) {
        return
      }

      const sendResult = {
        purchaseDate: values.purchaseDate,
        value: values.valueShopping,
        interest: values.interest,
        description: values.description,
        diferido: values.quotas,
        amortizationsProductId: values.productId,
        details: values.detailsShopping
      }

      if (isEdit.value) {
        messageConfirmSave('', 'Actualizar Compras', 'warning', '¿Esta seguro de actualiza el registro de las compras?').then(({ isConfirmed }) => {
          if (isConfirmed) {
            delete sendResult.details

            updateShopping(route.params.id, sendResult).then(async ({ status, data: resp }) => {
              if (status === 200) {
                const saveDetail = {
                  purchaseDate: sendResult.purchaseDate,
                  diferido: sendResult.diferido,
                  amortizationsProductId: sendResult.amortizationsProductId,
                  id: route.params.id
                }
                const details = []
                modelo.detailsShopping.map((detail, index) => {
                  const resultDetail = {
                    quota: detail.quota,
                    value: detail.value,
                    interest: detail.interest
                  }

                  if (detail.id) {
                    updateShoppingDetails(detail.id, [resultDetail]).then(async ({ data, status }) => {
                      console.log(status)
                    }).catch((err) => {
                      // loader.hide()
                      console.error(err.message)
                      if (err.response.status) {
                        error(err.response.data.message)
                      }
                    })
                  } else {
                    delete detail.id
                    delete detail._key

                    details.push({
                      ...detail,
                      amortizationsShoppingId: route.params.id
                    })
                  }
                })

                saveDetail.details = details

                createShoppingDetails(saveDetail).then(({ data, status }) => {
                  console.log(status)
                }).catch((err) => {
                  // loader.hide()
                  console.error(err.message)
                  if (err.response.status) {
                    error(err.response.data.message)
                  }
                })

                await success('Compra actualizada exitosamente')
              }
            }).catch((err) => {
              // loader.hide()
              console.error(err.message)
              if (err.response.status) {
                error(err.response.data.message)
              }
            })
          }
        })
      } else {
        messageConfirmSave('', 'Registrar Compras', 'warning', '¿Esta seguro de guardar el registro de las compras?').then(({ isConfirmed }) => {
          if (isConfirmed) {
            createShopping(sendResult).then((res) => {
              // loader.hide()
              success('Compras registradas exitosamente')
              router.back()
            }).catch((err) => {
              // loader.hide()
              console.error(err.message)
              if (err.response.status) {
                error(err.response.data.message)
              }
            })
          }
        })
      }
    })

    onMounted(() => {
      loadDropdownFinancialProducts()

      if (isEdit.value) {
        const { id } = route.params
        fetchCreditCard(id)
        fetchDetailsShopping(id)
      }
    })

    return {
      getInfoCreditCard,
      banks,
      obligations,
      modelo,
      onSubmit,
      errors,
      listCreditCards,
      infoCreditCard,
      imageLink,
      bgGradient,
      addRowShopping,
      removeRowShopping,
      generateShoppings,
      infoDetailsShopping,
      isEdit
    }
  }
}
</script>

<style scoped>

.floating-button {
  position: fixed !important;
  bottom: 30px;
  right: 40px;
  z-index: 10050;
}

</style>
